import styled from "@emotion/styled";
import { StyledAnimatedSkeleton } from "shared/components/ModuleSkeleton/components/ModuleHeaderSkeleton/styled";

export const SkeletonTextLineLong = styled(StyledAnimatedSkeleton)`
  height: 10px;
  width: 312px;
`;

export const SkeletonTextLineShort = styled(StyledAnimatedSkeleton)`
  height: 14px;
  width: 108px;
`;
